module.exports = __webpack_public_path__ + "img/chuk.65719f4f.png";